import { ButtonProps, Flex } from '@chakra-ui/react';
import Button from '~/components/Button';
import { ArrowDownIcon, ArrowUpIcon } from '~/components/icons';

import { ModalClearFiltersButton } from './ModalClearFiltersButton';

interface Props extends ButtonProps {
  hasFilterSet?: boolean;
  isFiltersBoxVisible?: boolean;
  onClearFilters: () => void;
}

export const OpenFiltersButton: React.FC<Props> = ({
  hasFilterSet = false,
  isFiltersBoxVisible = false,
  onClearFilters,
  ...props
}) => (
  <Flex alignItems="center" alignSelf="end">
    {hasFilterSet && <ModalClearFiltersButton onClick={onClearFilters} />}

    <Button
      border="unset"
      colorScheme="primary"
      fontSize="md"
      fontWeight="medium"
      letterSpacing={0}
      paddingLeft={2}
      paddingRight={0}
      textTransform="uppercase"
      variant="no-background"
      {...props}
    >
      Filters
      {isFiltersBoxVisible ? (
        <ArrowUpIcon aria-label="hide" boxSize={2} margin={1} />
      ) : (
        <ArrowDownIcon aria-label="show" boxSize={2} margin={1} />
      )}
    </Button>
  </Flex>
);
